import React from "react";
import { Button } from "react-bootstrap";
import { utils, writeFile } from "xlsx";

const DownloadExcel = ({ data, columns, nameFile }) => {

  async function exportData() {
    let dataDecorated = dataDecorator();
    let ws = utils.json_to_sheet(dataDecorated);
    let wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Sheet1");
    await writeFile(wb, nameFile);
  }

  const dataDecorator = () =>{
    let response = data.map((item) => {
      let res = {};
      for (let i = 0; i < columns.length; i++){
        res = {...res, [columns[i]["title"]]: item[columns[i]["dataIndex"]]};
      }
      return res;
    });
    return response;
  };

  return (
    <Button className="custom-button " onClick={exportData}>
      Descargar Excel
    </Button>
  );
};

export default DownloadExcel;
